<template>
    <div class="seal-upload">

    <el-dialog title="印章剪裁示例"
                   :show-close="false"
                   :visible.sync="showExample"
                   append-to-body
                   width="790px">
            <div class="cropper-example-container">
                <div class="cropper-example-item"
                     v-for="(image, index) in images"
                     :key="index">
                    <img class="item-img"
                         :src="image"
                         alt>
                </div>
            </div>
            <div slot="footer"
                 class="text-center">
                <el-button type="primary"
                           @click="showExample = false">我知道了</el-button>
            </div>
        </el-dialog>


        <!-- 剪裁区域 -->
        <div class="seal-wrapper">

            <p class="small-font"
               v-if="isSign">
                • 请尽量沿边沿剪裁，推荐200*80以内
            </p>
            <p class="small-font"
               v-else>• 请尽量沿边沿剪裁，推荐200*200以内
               <el-button type="text"
                           @click="showExample = true"
                           class="small-font">查看正确的剪裁示例</el-button>
            </p>

            <!-- 剪裁组件 -->
            <div class="vue-cropper-container">
                <vue-cropper ref="cropper"
                             :autoCrop="true"
                             :img="option.img"
                             :outputSize="option.size"
                             :outputType="option.outputType"
                             :info="true"
                             :fixed="true"
                             :fixedNumber="option.fixedNumber"
                             :full="option.full"
                             @realTime="realTime">
                </vue-cropper>
                <div class="handle-button">
                    <i class="icondelete"
                       @click="drawdown"></i>
                    <i class="iconadd"
                       @click="enlarger"></i>
                    <i class="iconrotate-left"
                       @click="rotate('left')"></i>
                    <i class="iconrotate-right"
                       @click="rotate('right')"></i>
                </div>
            </div>
            <p class="small-font">印章规格：{{sepcLabel}}</p>
        </div>

        <!-- 预览 -->
        <div class="preview-menu">

            <p class="preview-menu-title">预览</p>
            <div class="preview">
                <div class="preview-container transform-center"
                     ref="preview">
                    <img ref="previewImg"
                         :src="modelSrc"
                         class="middle-center"
                         @load="Utils.successLoadImg" />
                    <img ref="originalImg"
                         :src="modelSrc"
                         style="position:absolute; clip:rect(0 0 0 0);">
                </div>
            </div>

            <!-- 章操作区 -->
            <div class="LP-handle-button">
                <div class="auto-handle">
                    <p class="preview-menu-title">印章效果</p>
                    <p class="small-font text-left mb10 blue-text">请将图片尽可能调整至清晰可辨，红白分明</p>
                    <div class="auto-handle-button">
                        <div @click="changeEffect('auto')">
                            <i class="iconzidong-copy"
                               :class="defaultEffect === 'auto'? 'red-text': 'grey-text'"></i>
                            <p :class="defaultEffect === 'auto'? 'effect-desc': 'no-effect-desc'">自动</p>
                        </div>
                        <div @click="changeEffect('light')">
                            <i class="iconzengliang-copy"
                               :class="defaultEffect === 'light'? 'red-text': 'grey-text'"></i>
                            <p :class="defaultEffect === 'light'? 'effect-desc': 'no-effect-desc'">增亮</p>
                        </div>
                        <div @click="changeEffect('sharpen')">
                            <i class="iconzengqiangruihua-copy"
                               :class="defaultEffect === 'ausharpeno'? 'red-text': 'grey-text'"></i>
                            <p :class="defaultEffect === 'sharpen'? 'effect-desc': 'no-effect-desc'">增强锐化</p>
                        </div>
                    </div>
                </div>
                <div class="manual-handle">
                    <p class="preview-menu-title">效果调整</p>
                    <div class="manual-handle-button">
                        <div class="handle-light">
                            <span class="handle-desc">亮度</span>
                            <el-slider v-model="light"
                                       :format-tooltip="formatTooltip"
                                       @change="changeBrightness"></el-slider>
                        </div>
                        <div class="handle-sharpen">
                            <span class="handle-desc">对比度</span>
                            <el-slider v-model="contrast"
                                       :format-tooltip="formatTooltip"
                                       @change="changeContrast"></el-slider>
                        </div>
                    </div>
                </div>
                <div class="upload-button">
                    <div>
                        <el-button @click="doSaveImage"
                                   class="complete-button"
                                   type="primary">完成</el-button>
                    </div>
                    <div>
                        <label class="el-button reload-button el-button--default is-plain"
                               for="uploads"
                               @click="cancelCrop">
                            重新上传
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueCropper from 'vue-cropper';
import AI from './alloyImage';

let onmessageinAI = window.onmessage;
window.onmessage = function (e) {
    let t = e.data;
    if (e.data && t[0] == 'act' && t[0] == 'add') {
        onmessageinAI(e);
    }
};
export default {
    components: {
        'vue-cropper': VueCropper
    },
    props: {
        specs: {
            type: Array,
            // required: true,
            default: () => {
                return [];
            }
        },
        isPersonal: Boolean,
        imgUrl: {
            type: String,
            // required: true
        },
        // 自定义初始化选中规格
        defaultSpec: {
            type: String,
            default: ''
        },
        // 印章 签名 描述父组件自定义
        sealType: {
            typs: String,
            default: 'personal'
        },
        dataType: {
            type: String,
            default: ''
        },
        fixedSize: {
            type: Array,
            default: () => {
                return [1, 1];
            }
        },
        showExample: Boolean
    },
    data () {
        return {
             images: [
                        require('../../assets/images/seal/cropper-example001.png'),
                        require('../../assets/images/seal/cropper-example002.png'),
                        require('../../assets/images/seal/cropper-example003.png'),
                    ],
            key: '', // 保存到服务器图片key
            showSignEffect: false,
            file: {}, // 上传图片对象
            sealSpecs: this.specs,
            spec: this.defaultSpec,
            sealDes: this.isSign ? '签名' : '印章',
            modelSrc: '',
            dialogVisible: false,
            defaultEffect: '',                                                //默认设定效果：自动、增量、增强锐化,
            contrast: 50,                                                         //对比
            light: 50,                                                           //亮度
            $previews: {},
            $img: {},
            adjustSrc: '',                                                       //调整后base64
            originalImg: {},
            previewSrc: '',                                                     //最终显示出来的src
        };
    },
    watch: {
        modelSrc () {
            this.light = 50;
            this.contrast = 50;
            this.defaultEffect = '';
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.startCrop();
        });
        this.$previews = this.$refs.preview;
        this.$img = this.$refs.previewImg;
        this.originalImg = this.$refs.originalImg;
    },
    computed: {
        isSign () {
            return this.sealType == 'personal';
        },
        sepcLabel () {
            return this.isSign ? '40mm X 16mm' : '42mm X 42mm'
        },
        // vue-cropper配置参数
        option () {
            let select = this.sealSpecs.find(spec => spec.key == this.spec);
            let rate;
            if (select) {
                rate = [select.width, select.height];
            } else if (this.sealType === 'normal') {
                rate = this.fixedSize;
            } else if (this.isSign) {
                rate = [2.5, 1];
            } else {
                rate = [1, 1];
            }
            return {
                img: this.imgUrl,
                size: 1,
                outputType: 'png',
                fixedNumber: rate
            };
        }
    },
    methods: {
        //格式化滑块
        formatTooltip (val) {
            return ((val - 50) / 50).toFixed(2);
        },
        //亮度调节
        changeBrightness (val) {
            this.defaultEffect = '';
            let light = (val - 50) * 0.4;
            AlloyImage(this.originalImg).act('brightness', light, this.contrast - 50).replace(this.$img);
        },
        //对比调节
        changeContrast (val) {
            this.defaultEffect = '';
            let contrast = val - 50;
            AlloyImage(this.originalImg).act('brightness', (this.light - 50) * 0.4, contrast).replace(this.$img);
        },
        enlarger () {
            this.$refs.cropper.changeScale(1);
        },
        drawdown () {
            this.$refs.cropper.changeScale(-1);
        },
        startCrop () {
            this.$refs.cropper.startCrop();
        },
        stopCrop () {
            this.$refs.cropper.stopCrop();
        },
        clearCrop () {
            this.$refs.cropper.clearCrop();
        },
        // 实时预览函数
        realTime () {
            this.$refs.cropper.getCropData(data => {
                this.modelSrc = data;
            });
        },
        doShowExample () {
            this.$emit('update:showExample', true);
        },
        //上传图片
        uploadImg (event) {
            this.$emit('onUpload', event);
        },
        getImgSize(base64url) {
            const fileLength=parseInt(base64url.length-(base64url.length/8)*2);
            const size = (fileLength / 1024).toFixed(2) + "";
            return size;
        },
        // 保存图片
        doSaveImage () {
            this.adjustSrc = this.$img.src;
            // if(this.sealType !=='personal' && this.getImgSize(this.adjustSrc)>20){
            //     this.$message.error('上传图片大小不能超过 20KB！');
            //     return;
            // }
            // 根据类型 返回对应的图片格式
            if (this.dataType === 'bold') {
                this.getBase64().then(base64 => {
                    this.$refs.cropper.getCropBlob(boldData => {
                        this.$emit('onSaveImage', this.spec, base64, boldData);
                    });
                });
            } else {
                this.getBase64().then(() => {
                    this.$emit('onSaveImage', this.spec, this.adjustSrc);
                });
            }
        },
        getBase64 () {
            return new Promise((resolve) => {
                this.$refs.cropper.getCropData(data => {
                    resolve(data);
                });
            });
        },
        // 旋转图片
        rotate (type) {
            if (type == 'left') {
                this.$refs.cropper.rotateLeft();
            } else {
                this.$refs.cropper.rotateRight();
            }
        },
        cancel () {
            this.$emit('onCancel');
        },
        changeEffect (effect) {
            this.contrast = 50;
            this.light = 50;
            if (this.defaultEffect === effect) {
                this.$img.src = this.modelSrc;
                this.defaultEffect = '';
            } else {
                this.defaultEffect = effect;
                if (effect == 'auto') {
                    AlloyImage(this.originalImg).ps('softEnhancement').replace(this.$img);
                } else if (effect == 'light') {
                    AlloyImage(this.originalImg).ps('strongEnhancement').replace(this.$img);
                } else if (effect == 'sharpen') {
                    AlloyImage(this.originalImg).act('sharp', 10).replace(this.$img);
                }
            }
        },
        cancelCrop () {
            this.$emit('onCancel');
        }
    }
};
</script>
<style lang="less" scoped>
.tooltip {
    display: inline-block;
    background: #d9d9d9;
    cursor: pointer;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    color: #fff;
    margin-left: 15px;
    line-height: 14px;
    &:hover {
        background: @blue;
    }
}

.strong {
    font-weight: bold;
}
.seal-upload {
    line-height: 1.43121;

    .preview-menu-title {
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        margin-top: 10px;
    }
    .LP-handle-button {
        margin-top: 20px;
        .auto-handle-button {
            display: flex;
            justify-content: space-around;
            > div {
                i {
                    font-size: 32px;
                }
                .no-effect-desc {
                    color: #909399;
                }
                cursor: pointer;
            }
        }
        .handle-light,
        .handle-sharpen {
            height: 40px;
            line-height: 40px;
            text-align: left;
        }
        .reload-button {
            label {
                cursor: pointer;
            }
        }
    }
}
</style>
<style lang="less">
.seal-upload {
    position: relative;
    height: 740px;
    img {
        max-width: none;
    }

    .seal-wrapper {
        width: calc(~"100% - 300px");
        margin-right: 360px;
        height: 660px;
        padding: 0 20px;

        .vue-cropper-container {
            position: relative;

            .handle-button {
                text-align: center;
                width: 205px;
                height: 45px;
                line-height: 45px;
                position: absolute;
                border-radius: 6px;
                background: rgba(0, 0, 0, 0.6);
                bottom: 20px;
                margin: auto;
                left: 0;
                right: 0;

                i {
                    margin-right: 15px;
                    font-size: 22px;
                    color: #fff;
                    cursor: pointer;
                    user-select: none;
                    &:hover {
                        color: @primary;
                    }
                }
            }
        }
        .vue-cropper-container {
            height: calc(~"100% - 70px");
            .vue-cropper {
                background-image: none;
                background: rgba(0, 0, 0, 0.6);
                .cropper-modal {
                    background: rgba(0, 0, 0, 0);
                }
            }
        }
    }
    .preview-menu {
        width: 300px;
        position: absolute;
        right: 20px;
        top: 0;
        padding: 20px;
        color: #383838;
        text-align: center;
        z-index: 999;
        overflow-y: auto;
        overflow-x: hidden;
        .preview {
            width: 258px;
            height: 258px;
            display: inline-block;
            border: 1px solid #d0d0d0;
            position: relative;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
        }
        > p {
            text-align: left;
        }
        .preview-container {
            overflow: hidden;
            width: 256px;
            position: relative;
            height: 256px;
            canvas,
            img {
                max-width: 256px;
                max-height: 256px;
                height: auto !important;
            }
        }
        .handle-button {
            .el-button {
                display: block;
                margin: 10px auto;
            }
        }
    }
    .LP-handle-button {
        .handle-light,
        .handle-sharpen {
            .el-slider {
                float: right;
                width: 70%;
            }
        }
        .upload-button {
            .el-button {
                margin-top: 10px;
                width: 100%;
                letter-spacing: 6px;
            }
        }
    }
}
.cropper-example-container {
    overflow: hidden;
    .cropper-example-item {
        width: 230px;
        float: left;
        margin: 10px 10px;
        .item-img {
            display: block;
            width: 100%;
        }
    }
}
</style>
